import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  emDataService
} from 'app/services';
import {
  alerts,
  confirmDialog,
  actionIcon
} from 'app/components/global';
import department from './department';
import departmentsDirective from './departments.directive';
import processes from './processes';
import controller from './departments.controller';

export default angular.module('app.components.advisory.enterpriseModeling.departments', [
  ssDialogService,
  alerts,
  actionIcon,
  processes,
  loaderService,
  emDataService,
  confirmDialog,
  department
])
  .directive('emDepartments', departmentsDirective)
  .controller('DepartmentsController', controller)
  .name;

console.log('app.components.advisory.enterpriseModeling.departments created');
